module.exports = __webpack_public_path__ + "img/qr_code_sicantik.e8cf00bd.png";